export const documentsTranslations = {
  en: {
    // Main documents page
    'documents.title': 'Document Archive',
    'documents.subtitle': 'Access our comprehensive collection of construction documents, reports, and publications.',
    
    // Document magazine label
    'documents.magazine': 'DOCUMENT',
    
    // Download button
    'documents.download': 'Download PDF',
    
    // No documents section
    'documents.noDocuments.title': 'No Documents Available',
    'documents.noDocuments.message': 'We are currently updating our document library. Please check back soon.',
    
    // CTA section
    'documents.cta.title': 'Need More Information?',
    'documents.cta.subtitle': 'Contact our team for additional documents or specific information about our projects.',
    'documents.cta.button': 'Contact Us',
    
    // Document entries - April 2019
    'documents.april2019.title': 'Construction Safety Guidelines',
    'documents.april2019.date': 'April 2019',
    'documents.april2019.volume': 'VOLUME 1',
    'documents.april2019.issue': 'ISSUE 1',
    
    // Document entries - March 2019
    'documents.march2019.title': 'Project Management Standards',
    'documents.march2019.date': 'March 2019',
    'documents.march2019.volume': 'VOLUME 1',
    'documents.march2019.issue': 'ISSUE 2',
    
    // Document entries - February 2019
    'documents.february2019.title': 'Quality Control Procedures',
    'documents.february2019.date': 'February 2019',
    'documents.february2019.volume': 'VOLUME 1',
    'documents.february2019.issue': 'ISSUE 3',
    
    // Document entries - January 2019
    'documents.january2019.title': 'Building Code Compliance',
    'documents.january2019.date': 'January 2019',
    'documents.january2019.volume': 'VOLUME 1',
    'documents.january2019.issue': 'ISSUE 4',
    
    // Document entries - December 2018
    'documents.december2018.title': 'Sustainability Report',
    'documents.december2018.date': 'December 2018',
    'documents.december2018.volume': 'VOLUME 1',
    'documents.december2018.issue': 'ISSUE 5',
    
    // Document entries - November 2018
    'documents.november2018.title': 'Safety Training Manual',
    'documents.november2018.date': 'November 2018',
    'documents.november2018.volume': 'VOLUME 1',
    'documents.november2018.issue': 'ISSUE 6',
    
    // Document entries - October 2018
    'documents.october2018.title': 'Equipment Maintenance Guide',
    'documents.october2018.date': 'October 2018',
    'documents.october2018.volume': 'VOLUME 1',
    'documents.october2018.issue': 'ISSUE 7',
    
    // Document entries - September 2018
    'documents.september2018.title': 'Site Planning Handbook',
    'documents.september2018.date': 'September 2018',
    'documents.september2018.volume': 'VOLUME 1',
    'documents.september2018.issue': 'ISSUE 8',
    
    // Document entries - August 2018
    'documents.august2018.title': 'Design Standards Manual',
    'documents.august2018.date': 'August 2018',
    'documents.august2018.volume': 'VOLUME 1',
    'documents.august2018.issue': 'ISSUE 9',
  },
  ar: {
    // Main documents page
    'documents.title': 'أرشيف المستندات',
    'documents.subtitle': 'الوصول إلى مجموعتنا الشاملة من مستندات البناء والتقارير والمنشورات.',
    
    // Document magazine label
    'documents.magazine': 'مستند',
    
    // Download button
    'documents.download': 'تحميل PDF',
    
    // No documents section
    'documents.noDocuments.title': 'لا توجد مستندات متاحة',
    'documents.noDocuments.message': 'نحن نقوم حالياً بتحديث مكتبة المستندات. يرجى التحقق مرة أخرى قريباً.',
    
    // CTA section
    'documents.cta.title': 'تحتاج مزيداً من المعلومات؟',
    'documents.cta.subtitle': 'تواصل مع فريقنا للحصول على مستندات إضافية أو معلومات محددة حول مشاريعنا.',
    'documents.cta.button': 'اتصل بنا',
    
    // Document entries - April 2019
    'documents.april2019.title': 'إرشادات سلامة البناء',
    'documents.april2019.date': 'أبريل ٢٠١٩',
    'documents.april2019.volume': 'المجلد ١',
    'documents.april2019.issue': 'العدد ١',
    
    // Document entries - March 2019
    'documents.march2019.title': 'معايير إدارة المشاريع',
    'documents.march2019.date': 'مارس ٢٠١٩',
    'documents.march2019.volume': 'المجلد ١',
    'documents.march2019.issue': 'العدد ٢',
    
    // Document entries - February 2019
    'documents.february2019.title': 'إجراءات مراقبة الجودة',
    'documents.february2019.date': 'فبراير ٢٠١٩',
    'documents.february2019.volume': 'المجلد ١',
    'documents.february2019.issue': 'العدد ٣',
    
    // Document entries - January 2019
    'documents.january2019.title': 'امتثال رمز البناء',
    'documents.january2019.date': 'يناير ٢٠١٩',
    'documents.january2019.volume': 'المجلد ١',
    'documents.january2019.issue': 'العدد ٤',
    
    // Document entries - December 2018
    'documents.december2018.title': 'تقرير الاستدامة',
    'documents.december2018.date': 'ديسمبر ٢٠١٨',
    'documents.december2018.volume': 'المجلد ١',
    'documents.december2018.issue': 'العدد ٥',
    
    // Document entries - November 2018
    'documents.november2018.title': 'دليل تدريب السلامة',
    'documents.november2018.date': 'نوفمبر ٢٠١٨',
    'documents.november2018.volume': 'المجلد ١',
    'documents.november2018.issue': 'العدد ٦',
    
    // Document entries - October 2018
    'documents.october2018.title': 'دليل صيانة المعدات',
    'documents.october2018.date': 'أكتوبر ٢٠١٨',
    'documents.october2018.volume': 'المجلد ١',
    'documents.october2018.issue': 'العدد ٧',
    
    // Document entries - September 2018
    'documents.september2018.title': 'كتيب تخطيط الموقع',
    'documents.september2018.date': 'سبتمبر ٢٠١٨',
    'documents.september2018.volume': 'المجلد ١',
    'documents.september2018.issue': 'العدد ٨',
    
    // Document entries - August 2018
    'documents.august2018.title': 'دليل معايير التصميم',
    'documents.august2018.date': 'أغسطس ٢٠١٨',
    'documents.august2018.volume': 'المجلد ١',
    'documents.august2018.issue': 'العدد ٩',
  }
};
